import { useMutation } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { CampaignConfig } from 'schemas/CampaignConfig.schema.ts';
import { apiFetch } from 'utils/apiUtils.ts';
import { CreateCampaignAPIResponse } from 'schemas/CampaignCreateApi.schema';

export default function useCreateCampaign() {
  const { tokens } = useAuth();

  return useMutation({
    mutationFn: async ({
      teamId,
      campaign,
    }: {
      teamId: string;
      campaign: CampaignConfig;
    }) => apiFetch<CreateCampaignAPIResponse>({
      path: `team/${teamId}/campaign`,
      method: 'POST',
      accessToken: String(tokens.accessToken),
      body: campaign.CampaignConfig,
    }),
  });
}
